/**
 * The lot card's identity line under the title: «Площадка · № лота · Тип
 * процедуры».
 *
 * A Pro client comparing our card with TenderZone (2026-10-09) could not tell
 * which platform a lot sat on or under which number. The platform and the
 * number are source identity — together they find the lot at the origin portal,
 * where the contacts we sell are free — so they stay Pro-only (owner decision,
 * release 2026-10-06-a): the API omits both for anyone else, and `unlocked` gates
 * them again here so a web build that lands ahead of the API cannot print them.
 * The procedure type («Eng yaxshi takliflarni tanlash», «Проектно-изыскательный»)
 * is understanding, not identity, and is shown to everyone.
 */
export interface LotIdentityPart {
  key: 'platform' | 'lotNumber' | 'method';
  /** Short muted prefix, when the value alone would not say what it is. */
  label: string | null;
  value: string;
}

export function lotIdentityParts(input: {
  unlocked: boolean;
  sourceName: string | null | undefined;
  lotNumber: string | null | undefined;
  method: string | null | undefined;
  labels: { platform: string; method: string };
}): LotIdentityPart[] {
  const parts: LotIdentityPart[] = [];
  const clean = (v: string | null | undefined): string => (v ?? '').trim();
  if (input.unlocked) {
    const platform = clean(input.sourceName);
    if (platform) parts.push({ key: 'platform', label: input.labels.platform, value: platform });
    const lot = clean(input.lotNumber);
    if (lot) parts.push({ key: 'lotNumber', label: '№', value: lot });
  }
  const method = clean(input.method);
  if (method) parts.push({ key: 'method', label: `${input.labels.method}:`, value: method });
  return parts;
}
